export default "__VITE_ASSET__CLoEg0ge__"